import React, { useState, useEffect } from "react";
import CardComponent from "./lib/CardComponent";
import { connect } from "react-redux";
import CustomizedSelect from "../customizedSelect";
import { Input } from "../../../forms/input";
import { Checkbox } from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MenuItem from "@material-ui/core/MenuItem";
import {
  genderOptions,
  NomineesList,
  panRegex,
  emailRegex,
  nameRegex,
} from ".";
import { $wait, checkIfMinor } from "./lib/utils";
import CustomLoader from "../../../forms/Loader";
import {
  getCountriesList,
  storeNomineeDetails,
  getStatesList,
  storeApplicantParams,
  getKycDetails,
  checkKyc,
  getCitiesList as getCitiesByState,
  getRelationShipList,
  getNomineeDetails,
} from "../../../../store/actions";
import { format } from "date-fns";

import DateFnsUtils from "@date-io/date-fns";

const NomineeDetails = (props) => {
  const first_nominee_details = {
    name: { value: "" },
    pan: { value: "" },
    relationship: { value: "" },
    otherrelationship: { value: "" },
    dob: { value: "" },
    gender: { value: "" },
    percentage: { value: "100" },
    email: { value: "" },
    address: { value: "" },
    country: { value: "" },
    state: { value: "" },
    city: { value: "" },
    pincode: { value: "" },
    gaurdianname: { value: "" },
    gaurdianpan: { value: "" },
    gaurdianrelationship: { value: "" },
  };
  const second_nominee_details = {
    name: { value: "" },
    pan: { value: "" },
    relationship: { value: "" },
    otherrelationship: { value: "" },
    dob: { value: "" },
    gender: { value: "" },
    percentage: { value: "100" },
    email: { value: "" },
    address: { value: "" },
    country: { value: "" },
    state: { value: "" },
    city: { value: "" },
    pincode: { value: "" },
    gaurdianname: { value: "" },
    gaurdianpan: { value: "" },
    gaurdianrelationship: { value: "" },
  };
  const third_nominee_details = {
    name: { value: "" },
    pan: { value: "" },
    relationship: { value: "" },
    otherrelationship: { value: "" },
    dob: { value: "" },
    gender: { value: "" },
    percentage: { value: "100" },
    email: { value: "" },
    address: { value: "" },
    country: { value: "" },
    state: { value: "" },
    city: { value: "" },
    pincode: { value: "" },
    gaurdianname: { value: "" },
    gaurdianpan: { value: "" },
    gaurdianrelationship: { value: "" },
  };
  const [isLoading, setIsLoading] = useState(false);
  const [NomineeListShow, setIsNomineeListShow] = useState(true);

  const [nominate_yes_or_no, setnominate_yes_or_no] = useState(false);
  const [countriesList, setcountriesList] = useState([]);
  const [nominees_selected, setnomineeSelected] = useState({
    nominee_selected1: "",
    nominee_selected2: "",
    nominee_selected3: "",
  });
  const [nomineeList, setnomineeList] = useState([]);
  const [relationshipList, setrelationshipList] = useState([]);
  const [same_as_first_appicant_address, setsame_as_first_appicant_address] =
    useState(false);
  const list = "1";
  const [nominee_dateofbirth, setnominee_dateofbirth] = useState({
    first_nominee_dateofbirth: false,
    second_nominee_dateofbirth: false,
    third_nominee_dateofbirth: false,
  });
  const [nominee_list, setnominee_list] = useState(list);
  const [first_nomineeDetails, setfirst_nomineeDetails] = useState(
    first_nominee_details
  );
  const [second_nomineeDetails, setsecond_nomineeDetails] = useState(
    second_nominee_details
  );
  const [third_nomineeDetails, setthird_nomineeDetails] = useState(
    third_nominee_details
  );
  const prefillFormValues = async () => {
    setIsLoading(true);
    setfirst_nomineeDetails({
      ...first_nomineeDetails,
      address: { value: props.address.address ? props.address.address : "" },
      country: { value: !!props.address.country ? props.address.country : "" },
      state: { value: !!props.address.state ? props.address.state : "" },
      pincode: { value: !!props.address.pincode ? props.address.pincode : "" },
      city: { value: !!props.address.city ? props.address.city : "" },
    });
    setsecond_nomineeDetails({
      ...second_nomineeDetails,
      address: { value: props.address.address ? props.address.address : "" },
      country: { value: !!props.address.country ? props.address.country : "" },
      state: { value: !!props.address.state ? props.address.state : "" },
      pincode: { value: !!props.address.pincode ? props.address.pincode : "" },
      city: { value: !!props.address.city ? props.address.city : "" },
    });
    setthird_nomineeDetails({
      ...third_nomineeDetails,
      address: { value: props.address.address ? props.address.address : "" },
      country: { value: !!props.address.country ? props.address.country : "" },
      state: { value: !!props.address.state ? props.address.state : "" },
      pincode: { value: !!props.address.pincode ? props.address.pincode : "" },
      city: { value: !!props.address.city ? props.address.city : "" },
    });
    setIsLoading(false);
  };
  const handleAddress = async () => {
    setsame_as_first_appicant_address(!same_as_first_appicant_address);

    if (same_as_first_appicant_address == false) {
      await prefillFormValues();
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        address: { value: props.address.address ? props.address.address : "" },
        country: {
          value: !!props.address.country ? props.address.country : "",
        },
        state: { value: !!props.address.state ? props.address.state : "" },
        pincode: {
          value: !!props.address.pincode ? props.address.pincode : "",
        },
        city: { value: !!props.address.city ? props.address.city : "" },
      });
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        address: { value: props.address.address ? props.address.address : "" },
        country: {
          value: !!props.address.country ? props.address.country : "",
        },
        state: { value: !!props.address.state ? props.address.state : "" },
        pincode: {
          value: !!props.address.pincode ? props.address.pincode : "",
        },
        city: { value: !!props.address.city ? props.address.city : "" },
      });
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        address: { value: props.address.address ? props.address.address : "" },
        country: {
          value: !!props.address.country ? props.address.country : "",
        },
        state: { value: !!props.address.state ? props.address.state : "" },
        pincode: {
          value: !!props.address.pincode ? props.address.pincode : "",
        },
        city: { value: !!props.address.city ? props.address.city : "" },
      });
    } else {
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        address: { value: "" },
        country: { value: "" },
        state: { value: "" },
        pincode: { value: "" },
        city: { value: "" },
      });
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        address: { value: "" },
        country: { value: "" },
        state: { value: "" },
        pincode: { value: "" },
        city: { value: "" },
      });
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        address: { value: "" },
        country: { value: "" },
        state: { value: "" },
        pincode: { value: "" },
        city: { value: "" },
      });
    }
  };
  const handleChangeNomineeList = async (event) => {
    const value = event.target.value;
    setnominee_list(event.target.value);
    if (value == "1") {
      setIsLoading(true);
      await $wait(10);
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        percentage: { value: "100" },
      });
      setIsLoading(false);
    }
    if (value == "2") {
      setIsLoading(true);
      await $wait(10);
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        percentage: { value: "50" },
      });
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        percentage: { value: "50" },
      });
      setIsLoading(false);
    }
    if (value == "3") {
      setIsLoading(true);
      await $wait(10);
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        percentage: { value: "33.3" },
      });
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        percentage: { value: "33.3" },
      });
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        percentage: { value: "33.4" },
      });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    firstRender();
  }, []);
  const firstRender = async () => {
    await getLists();
    // await prefillFormValues();
    checkReduxStore();
  };
  useEffect(() => {
    nomineelist();
  }, [nomineeList.length === 0]);
  const nomineelist = async () => {
    await NomineeDetails();
  };
  const checkReduxStore = () => {
    if (!!props.nomineDetails && !!props.nomineDetails.i_nominee) {
      const { nomineDetails } = props;
      const {
        i_nominee,
        i_nominee2,
        i_nominee3,
        i_nompan1,
        i_nompan2,
        i_nompan3,
        i_NomRelation,
        i_NomRelation2,
        i_NomRelation3,
        i_NomDOB,
        i_NomDOB2,
        i_NomDOB3,
        nom1gender,
        nom2gender,
        nom3gender,
        i_Nominee1percentage,
        i_Nominee2percentage,
        i_Nominee3percentage,
        nom1email,
        nom2email,
        nom3email,
        i_nomadd1,
        i_nomadd21,
        i_nomadd31,
        i_nomcountry,
        i_nom2country,
        i_nom3country,
        i_nomstate,
        i_nomstate2,
        i_nomstate3,
        i_nomcity,
        i_nomcity2,
        i_nomcity3,
        i_nompin,
        i_nompin2,
        i_nompin3,
        i_nomguardianname1,
        i_nomguardianname3,
        i_nomguardianpan1,
        i_nomguardianpan3,
        i_nomguardianname2,
        i_namguardianrelationship1,
        i_namguardianrelationship3,
        i_namguardianrelationship2,
        i_nomguardianpan2,
      } = nomineDetails;
      setnominate_yes_or_no(!!i_nominee ? false : true);
      setnominee_list(
        !!i_nominee3 ? "3" : !!i_nominee2 ? "2" : !!i_nominee ? "1" : ""
      );
      if (!!i_nominee) {
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          name: { value: i_nominee },
          pan: { value: i_nompan1 },
          relationship: { value: i_NomRelation },
          dob: { value: i_NomDOB },
          gender: { value: nom1gender },
          percentage: { value: i_Nominee1percentage },
          email: { value: nom1email },
          address: { value: i_nomadd1 },
          country: { value: i_nomcountry },
          state: { value: i_nomstate },
          city: { value: i_nomcity },
          pincode: { value: i_nompin },
        });
      }
      if (!!i_nominee2) {
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          name: { value: i_nominee2 },
          pan: { value: i_nompan2 },
          relationship: { value: i_NomRelation2 },
          dob: { value: i_NomDOB2 },
          gender: { value: nom2gender },
          percentage: { value: i_Nominee2percentage },
          email: { value: nom2email },
          address: { value: i_nomadd21 },
          country: { value: i_nom2country },
          state: { value: i_nomstate2 },
          city: { value: i_nomcity2 },
          pincode: { value: i_nompin2 },
        });
      }
      if (!!i_nominee3) {
        setthird_nomineeDetails({
          ...third_nomineeDetails,
          name: { value: i_nominee3 },
          pan: { value: i_nompan3 },
          relationship: { value: i_NomRelation3 },
          dob: { value: i_NomDOB3 },
          gender: { value: nom3gender },
          percentage: { value: i_Nominee3percentage },
          email: { value: nom3email },
          address: { value: i_nomadd31 },
          country: { value: i_nom3country },
          state: { value: i_nomstate3 },
          city: { value: i_nomcity3 },
          pincode: { value: i_nompin3 },
        });
      }
      let new_nominee_dateofbirth = nominee_dateofbirth;
      if (!!i_NomDOB && checkIfMinor(i_NomDOB)) {
        new_nominee_dateofbirth.first_nominee_dateofbirth = true;

        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          name: { value: i_nominee },
          pan: { value: i_nompan1 },
          relationship: { value: i_NomRelation },
          dob: { value: i_NomDOB },
          gender: { value: nom1gender },
          percentage: { value: i_Nominee1percentage },
          email: { value: nom1email },
          address: { value: i_nomadd1 },
          country: { value: i_nomcountry },
          state: { value: i_nomstate },
          city: { value: i_nomcity },
          pincode: { value: i_nompin },
          gaurdianname: { value: i_nomguardianname1 },
          gaurdianpan: { value: i_nomguardianpan1 },
          gaurdianrelationship: { value: i_namguardianrelationship1 },
        });
      }
      if (!!i_NomDOB2 && checkIfMinor(i_NomDOB2)) {
        new_nominee_dateofbirth.second_nominee_dateofbirth = true;
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          name: { value: i_nominee2 },
          pan: { value: i_nompan2 },
          relationship: { value: i_NomRelation2 },
          dob: { value: i_NomDOB2 },
          gender: { value: nom2gender },
          percentage: { value: i_Nominee2percentage },
          email: { value: nom2email },
          address: { value: i_nomadd21 },
          country: { value: i_nom2country },
          state: { value: i_nomstate2 },
          city: { value: i_nomcity2 },
          pincode: { value: i_nompin2 },
          gaurdianname: { value: i_nomguardianname2 },
          gaurdianpan: { value: i_nomguardianpan2 },
          gaurdianrelationship: { value: i_namguardianrelationship2 },
        });
      }
      if (!!i_NomDOB3 && checkIfMinor(i_NomDOB3)) {
        new_nominee_dateofbirth.third_nominee_dateofbirth = true;
        setthird_nomineeDetails({
          ...third_nomineeDetails,
          name: { value: i_nominee3 },
          pan: { value: i_nompan3 },
          relationship: { value: i_NomRelation3 },
          dob: { value: i_NomDOB3 },
          gender: { value: nom3gender },
          percentage: { value: i_Nominee3percentage },
          email: { value: nom3email },
          address: { value: i_nomadd31 },
          country: { value: i_nom3country },
          state: { value: i_nomstate3 },
          city: { value: i_nomcity3 },
          pincode: { value: i_nompin3 },
          gaurdianname: { value: i_nomguardianname3 },
          gaurdianpan: { value: i_nomguardianpan3 },
          gaurdianrelationship: { value: i_namguardianrelationship3 },
        });
      }
      setnominee_dateofbirth(new_nominee_dateofbirth);
    }
  };

  const NomineeDetails = async () => {
    setIsLoading(true);
    const params = {
      pan: props.store_pan,
    };
    const response = await props.getNomineeDetails(params);
    const nomineevalues = !!response.Dtinformation
      ? response.Dtinformation
      : [];
    if (response.Dtinformation.length === 0) {
      setIsNomineeListShow(false);
    }
    const nomineeList = nomineevalues.map((nominee) => {
      return { label: nominee.Nom1.trim(), value: nominee.Nom1.trim() };
    });
    nomineeList.push({ label: "Add New", value: "Add New" });
    setnomineeList(nomineeList);
    setIsLoading(false);
  };
  const getLists = async () => {
    const relationShipResponse = await props.getRelationShipList();
    const { Dtinformation } = relationShipResponse;
    const relationShipList = Dtinformation.map((item) => ({
      label: item.rm_relation,
      value: item.rm_relation,
    }));
    const countriesResponse = await props.getCountriesList();
    const Countries = countriesResponse.Dtinformation;
    const countriesList = Countries.map((country) => {
      return { label: country.country_name, value: country.country_name };
    });
    setcountriesList(
      countriesList.length > 0
        ? countriesList
        : [{ label: "India", value: "India" }]
    );
    setrelationshipList(relationShipList);
  };
  const handleDateofBirth = (label) => (event) => {
    const value = format(new Date(event), "MM/dd/yyyy");
    const oneday = 86400000;
    const today = new Date();
    const datevalue = new Date(value);
    if (label == "dob1") {
      const min18yersletnew = new Date(today.getTime() - oneday * 365 * 18);
      if (datevalue.getTime() > min18yersletnew) {
        setnominee_dateofbirth({
          ...nominee_dateofbirth,
          first_nominee_dateofbirth: true,
        });
      } else {
        setnominee_dateofbirth({
          ...nominee_dateofbirth,
          first_nominee_dateofbirth: false,
        });
      }
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        dob: { value: value },
      });
    }
    if (label == "dob2") {
      const min18yersletnew = new Date(today.getTime() - oneday * 365 * 18);
      if (datevalue.getTime() > min18yersletnew) {
        setnominee_dateofbirth({
          ...nominee_dateofbirth,
          second_nominee_dateofbirth: true,
        });
      } else {
        setnominee_dateofbirth({
          ...nominee_dateofbirth,
          second_nominee_dateofbirth: false,
        });
      }
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        dob: { value: value },
      });
    }
    if (label == "dob3") {
      const min18yersletnew = new Date(today.getTime() - oneday * 365 * 18);
      if (datevalue.getTime() > min18yersletnew) {
        setnominee_dateofbirth({
          ...nominee_dateofbirth,
          third_nominee_dateofbirth: true,
        });
      } else {
        setnominee_dateofbirth({
          ...nominee_dateofbirth,
          third_nominee_dateofbirth: false,
        });
      }
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        dob: { value: value },
      });
    }
  };
  const handleNomineeList = (label) => async (event) => {
    const RemovingTheNomineeMember = { value: event.target.value };
    if (nominee_list === "1") {
      if (RemovingTheNomineeMember.value === "Add New") {
        setfirst_nomineeDetails({ ...first_nominee_details });
        setnomineeSelected({
          ...nominees_selected,
          nominee_selected1: event.target.value,
        });
        return;
      }
      if (
        (RemovingTheNomineeMember.value !== "Add New" &&
          RemovingTheNomineeMember.value ===
            nominees_selected.nominee_selected3) ||
        nominees_selected.nominee_selected2
      ) {
        alert("Already this nominee has been selected");
        return;
      }
    }
    if (nominee_list === "2") {
      if (
        label === "nominee1" &&
        RemovingTheNomineeMember.value === "Add New"
      ) {
        setfirst_nomineeDetails({ ...first_nominee_details });
        setnomineeSelected({
          ...nominees_selected,
          nominee_selected1: event.target.value,
        });
        return;
      }
      if (
        label === "nominee2" &&
        RemovingTheNomineeMember.value === "Add New"
      ) {
        setsecond_nomineeDetails({ ...second_nominee_details });
        setnomineeSelected({
          ...nominees_selected,
          nominee_selected2: event.target.value,
        });
        return;
      }
      if (
        (RemovingTheNomineeMember.value !== "Add New" &&
          RemovingTheNomineeMember.value ===
            nominees_selected.nominee_selected1) ||
        RemovingTheNomineeMember.value === nominees_selected.nominee_selected1
      ) {
        alert("Already this nominee has been selected");
        return;
      }
    }
    if (nominee_list === "3") {
      if (label == "nominee1" && RemovingTheNomineeMember.value === "Add New") {
        setfirst_nomineeDetails({ ...first_nominee_details });
        setnomineeSelected({
          ...nominees_selected,
          nominee_selected1: event.target.value,
        });
        return;
      }
      if (label == "nominee2" && RemovingTheNomineeMember.value === "Add New") {
        setsecond_nomineeDetails({ ...second_nominee_details });
        setnomineeSelected({
          ...nominees_selected,
          nominee_selected2: event.target.value,
        });
        return;
      }
      if (label == "nominee3" && RemovingTheNomineeMember.value === "Add New") {
        setthird_nomineeDetails({ ...third_nominee_details });
        setnomineeSelected({
          ...nominees_selected,
          nominee_selected3: event.target.value,
        });
        return;
      }
      if (
        (label == "nominee1" &&
          RemovingTheNomineeMember.value !== "Add New" &&
          RemovingTheNomineeMember.value ===
            nominees_selected.nominee_selected3) ||
        RemovingTheNomineeMember.value === nominees_selected.nominee_selected2
      ) {
        alert("Already this nominee has been selected");
        return;
      }

      if (
        (label == "nominee2" &&
          RemovingTheNomineeMember.value !== "Add New" &&
          RemovingTheNomineeMember.value ===
            nominees_selected.nominee_selected3) ||
        RemovingTheNomineeMember.value === nominees_selected.nominee_selected1
      ) {
        alert("Already this nominee has been selected");
        return;
      }

      if (
        (label == "nominee3" &&
          RemovingTheNomineeMember.value !== "Add New" &&
          RemovingTheNomineeMember.value ===
            nominees_selected.nominee_selected2) ||
        RemovingTheNomineeMember.value === nominees_selected.nominee_selected1
      ) {
        alert("Already this nominee has been selected");
        return;
      }
    }
    const nomineedetails =
      !!props.getnomineeDetails &&
      props.getnomineeDetails.Dtinformation.find(
        (ele) => ele.Nom1.trim() === event.target.value.trim()
      );
    const oneday = 86400000;
    const today = new Date();
    if (!!nomineedetails && label === "nominee1") {
      if (!!nomineedetails.Nom1_Dob) {
        const value = new Date(nomineedetails.Nom1_Dob);
        const min18yersletnew = new Date(today.getTime() - oneday * 365 * 18);
        if (value.getTime() > min18yersletnew) {
          setnominee_dateofbirth({
            ...nominee_dateofbirth,
            first_nominee_dateofbirth: true,
          });
        } else {
          setnominee_dateofbirth({
            ...nominee_dateofbirth,
            first_nominee_dateofbirth: false,
          });
        }
      }
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        name: { value: nomineedetails?.Nom1 },
        relationship: {
          value:
            nomineedetails.Nom1Relation.charAt(0).toUpperCase() +
            nomineedetails.Nom1Relation.substr(1).toLowerCase(),
        },
        dob: { value: nomineedetails?.Nom1_Dob },
        gender: { value: nomineedetails.Nom1_Gender === "Male" ? "M" : "F" },
        address: {
          value:
            nomineedetails?.Nom1_Add1 +
            nomineedetails?.Nom1_Add2 +
            nomineedetails?.Nom1_Add3,
        },
        country: { value: nomineedetails?.Nom1_Country },
        state: { value: nomineedetails?.Nom1_state },
        pincode: { value: nomineedetails?.Nom1_pin },
        city: { value: nomineedetails?.Nom1_City },
      });
      setnomineeSelected({
        ...nominees_selected,
        nominee_selected1: event.target.value,
      });
    }

    if (!!nomineedetails && label === "nominee2") {
      if (!!nomineedetails.Nom2_Dob) {
        const value = new Date(nomineedetails.Nom2_Dob);
        const min18yersletnew = new Date(today.getTime() - oneday * 365 * 18);
        if (value.getTime() > min18yersletnew) {
          setnominee_dateofbirth({
            ...nominee_dateofbirth,
            second_nominee_dateofbirth: true,
          });
        } else {
          setnominee_dateofbirth({
            ...nominee_dateofbirth,
            second_nominee_dateofbirth: false,
          });
        }
      }
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        name: { value: nomineedetails?.Nom1 },
        relationship: {
          value:
            nomineedetails.Nom1Relation.charAt(0).toUpperCase() +
            nomineedetails.Nom1Relation.substr(1).toLowerCase(),
        },
        dob: { value: nomineedetails?.Nom1_Dob },
        gender: { value: nomineedetails.Nom1_Gender === "Male" ? "M" : "F" },
        address: {
          value:
            nomineedetails?.Nom1_Add1 +
            nomineedetails?.Nom1_Add2 +
            nomineedetails?.Nom1_Add3,
        },
        country: { value: nomineedetails?.Nom1_Country },
        state: { value: nomineedetails?.Nom1_state },
        pincode: { value: nomineedetails?.Nom1_pin },
        city: { value: nomineedetails?.Nom1_City },
      });
      setnomineeSelected({
        ...nominees_selected,
        nominee_selected2: event.target.value,
      });
    }
    if (!!nomineedetails && label === "nominee3") {
      if (!!nomineedetails.Nom3_Dob) {
        const value = new Date(nomineedetails.Nom3_Dob);
        const min18yersletnew = new Date(today.getTime() - oneday * 365 * 18);
        if (value.getTime() > min18yersletnew) {
          setnominee_dateofbirth({
            ...nominee_dateofbirth,
            third_nominee_dateofbirth: true,
          });
        } else {
          setnominee_dateofbirth({
            ...nominee_dateofbirth,
            third_nominee_dateofbirth: false,
          });
        }
      }
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        name: { value: nomineedetails?.Nom1 },
        relationship: {
          value:
            nomineedetails.Nom1Relation.charAt(0).toUpperCase() +
            nomineedetails.Nom1Relation.substr(1).toLowerCase(),
        },
        dob: { value: nomineedetails?.Nom1_Dob },
        gender: { value: nomineedetails.Nom1_Gender === "Male" ? "M" : "F" },
        address: {
          value:
            nomineedetails?.Nom1_Add1 +
            nomineedetails?.Nom1_Add2 +
            nomineedetails?.Nom1_Add3,
        },
        country: { value: nomineedetails?.Nom1_Country },
        state: { value: nomineedetails?.Nom1_state },
        pincode: { value: nomineedetails?.Nom1_pin },
        city: { value: nomineedetails?.Nom1_City },
      });
      setnomineeSelected({
        ...nominees_selected,
        nominee_selected3: event.target.value,
      });
    }
  };
  const showError = (label) => (event) => {
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (
      label === "firstNomineePan" &&
      event.target.value.charAt(3) !== "P" &&
      event.target.value.length === 10
    ) {
      alert(
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number"
      );
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        pan: { value: "" },
      });
      return;
    }
    if (
      label === "firstNomineePan" &&
      !regpan.test(event.target.value) &&
      event.target.value.length === 10
    ) {
      alert("Enter valid pan");
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        pan: { value: "" },
      });
      return;
    }
    if (
      label === "secondNomineePan" &&
      event.target.value.charAt(3) !== "P" &&
      event.target.value.length === 10
    ) {
      alert(
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number"
      );
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        pan: { value: "" },
      });
      return;
    }
    if (
      label === "secondNomineePan" &&
      !regpan.test(event.target.value) &&
      event.target.value.length === 10
    ) {
      alert("Enter valid pan");
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        pan: { value: "" },
      });
      return;
    }
    if (
      label === "thirdNomineePan" &&
      event.target.value.charAt(3) !== "P" &&
      event.target.value.length === 10
    ) {
      alert(
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number"
      );
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        pan: { value: "" },
      });
      return;
    }
    if (
      label === "thirdNomineePan" &&
      !regpan.test(event.target.value) &&
      event.target.value.length === 10
    ) {
      alert("Enter valid pan");
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        pan: { value: "" },
      });
      return;
    }
    if (
      label === "firstNomineeGuardianPan" &&
      event.target.value.charAt(3) !== "P" &&
      event.target.value.length === 10
    ) {
      alert(
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number"
      );
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        gaurdianpan: { value: "" },
      });
      return;
    }
    if (
      label === "firstNomineeGuardianPan" &&
      !regpan.test(event.target.value) &&
      event.target.value.length === 10
    ) {
      alert("Enter valid pan");
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        gaurdianpan: { value: "" },
      });
      return;
    }
    if (
      label === "secondNomineeGuardianPan" &&
      event.target.value.charAt(3) !== "P" &&
      event.target.value.length === 10
    ) {
      alert(
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number"
      );
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        gaurdianpan: { value: "" },
      });
      return;
    }
    if (
      label === "secondNomineeGuardianPan" &&
      !regpan.test(event.target.value) &&
      event.target.value.length === 10
    ) {
      alert("Enter valid pan");
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        gaurdianpan: { value: "" },
      });
      return;
    }
    if (
      label === "thirdNomineeGuardianPan" &&
      event.target.value.charAt(3) !== "P" &&
      event.target.value.length === 10
    ) {
      alert(
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number"
      );
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        gaurdianpan: { value: "" },
      });
      return;
    }
    if (
      label === "thirdNomineeGuardianPan" &&
      !regpan.test(event.target.value) &&
      event.target.value.length === 10
    ) {
      alert("Enter valid pan");
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        gaurdianpan: { value: "" },
      });
      return;
    }
  };

  const handleChangePan = (label) => (event) => {
    const arr = [
      { pan: props.store_pan },
      { pan: props.applicantparams.i_pangno2 },
      { pan: props.applicantparams.i_pangno3 },
      { pan: first_nomineeDetails.pan.value },
      { pan: second_nomineeDetails.pan.value },
      { pan: third_nomineeDetails.pan.value },
      { pan: first_nomineeDetails.gaurdianpan.value },
      { pan: second_nomineeDetails.gaurdianpan.value },
      { pan: third_nomineeDetails.gaurdianpan.value },
    ];
    const value = event.target.value.toUpperCase();
    if (label === "firstNomineePan" && value.length <= 10) {
      const search = arr.find((ele) => !!ele.pan && ele.pan === value);
      if (!!search) {
        alert("Nominee PAN,Primary Holder PAN and Guardian PAN cannot be same");
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          pan: { value: "" },
        });
        return;
      }
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        pan: { value: value },
      });
    }
    if (label === "secondNomineePan" && value.length <= 10) {
      const search = arr.find((ele) => !!ele.pan && ele.pan === value);
      if (!!search) {
        alert("Nominee PAN,Primary Holder PAN and Guardian PAN cannot be same");
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          pan: { value: "" },
        });
        return;
      }
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        pan: { value: value },
      });
    }
    if (label === "thirdNomineePan" && value.length <= 10) {
      const search = arr.find((ele) => !!ele.pan && ele.pan === value);
      if (!!search) {
        alert("Nominee PAN,Primary Holder PAN and Guardian PAN cannot be same");
        setthird_nomineeDetails({
          ...third_nomineeDetails,
          pan: { value: "" },
        });
        return;
      }

      setthird_nomineeDetails({
        ...third_nomineeDetails,
        pan: { value: value },
      });
    }
    if (label === "firstNomineeGuardianPan" && value.length <= 10) {
      const search = arr.find((ele) => !!ele.pan && ele.pan === value);
      if (!!search) {
        alert("Nominee PAN,Primary Holder PAN and Guardian PAN cannot be same");
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          gaurdianpan: { value: "" },
        });
        return;
      }

      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        gaurdianpan: { value: value },
      });
    }
    if (label === "secondNomineeGuardianPan" && value.length <= 10) {
      const search = arr.find((ele) => !!ele.pan && ele.pan === value);
      if (!!search) {
        alert("Nominee PAN,Primary Holder PAN and Guardian PAN cannot be same");
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          gaurdianpan: { value: "" },
        });
        return;
      }

      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        gaurdianpan: { value: value },
      });
    }
    if (label === "thirdNomineeGuardianPan" && value.length <= 10) {
      const search = arr.find((ele) => !!ele.pan && ele.pan === value);
      if (!!search) {
        alert("Nominee PAN,Primary Holder PAN and Guardian PAN cannot be same");
        setthird_nomineeDetails({
          ...third_nomineeDetails,
          gaurdianpan: { value: "" },
        });
        return;
      }
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        gaurdianpan: { value: value },
      });
    }
  };
  const handleState = (label) => (event) => {
    if (/^[a-zA-Z ]*$/.test(event.target.value) && label === "firstState") {
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        state: { value: event.target.value },
      });
    }
    if (/^[a-zA-Z ]*$/.test(event.target.value) && label === "secondState") {
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        state: { value: event.target.value },
      });
    }
    if (/^[a-zA-Z ]*$/.test(event.target.value) && label === "thirdState") {
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        state: { value: event.target.value },
      });
    }
  };
  const handleCity = (label) => (event) => {
    if (/^[a-zA-Z ]*$/.test(event.target.value) && label === "firstCity") {
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        city: { value: event.target.value },
      });
    }
    if (/^[a-zA-Z ]*$/.test(event.target.value) && label === "secondCity") {
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        city: { value: event.target.value },
      });
    }
    if (/^[a-zA-Z ]*$/.test(event.target.value) && label === "thirdCity") {
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        city: { value: event.target.value },
      });
    }
  };
  const handlePercentage = (label) => (event) => {
    const value = event.target.value;
    if (event.target.value <= 100) {
      if (label === "first" && nominee_list === "1") {
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          percentage: { value: value },
        });
      }
      if (nominee_list === "2" && (label === "second" || label === "first")) {
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          percentage:
            label === "second"
              ? { value: value }
              : { value: Math.abs(value - 100) },
        });
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          percentage:
            label === "first"
              ? { value: value }
              : { value: Math.abs(value - 100) },
        });
      }
      if (
        nominee_list === "3" &&
        (label === "first" || label === "second" || label === "third")
      ) {
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          percentage:
            label === "first"
              ? { value: value }
              : { value: Math.abs(value - 100) / 2 },
        });
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          percentage:
            label === "second"
              ? { value: value }
              : { value: Math.abs(value - 100) / 2 },
        });
        setthird_nomineeDetails({
          ...third_nomineeDetails,
          percentage:
            label === "third"
              ? { value: value }
              : { value: Math.abs(value - 100) / 2 },
        });
      }
    }
  };
  const handleNominees = () => {
    setnominate_yes_or_no(!nominate_yes_or_no);
    setfirst_nomineeDetails(first_nominee_details);
    setsecond_nomineeDetails(second_nominee_details);
    setthird_nomineeDetails(third_nominee_details);
  };
  const handlePincode = (label) => (event) => {
    const value = event.target.value;
    if (value.length <= 6) {
      if (label === "nominee1") {
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          pincode: { value: event.target.value },
        });
      }
      if (label === "nominee2") {
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          pincode: { value: event.target.value },
        });
      }

      if (label === "nominee3") {
        setthird_nomineeDetails({
          ...third_nomineeDetails,
          pincode: { value: event.target.value },
        });
      }
    }
  };
  const handleName = (label) => (event) => {
    const value = event.target.value;
    const arr = [
      { name: third_nomineeDetails.name.value },
      { name: second_nomineeDetails.name.value },
      { name: first_nomineeDetails.name.value },
    ];

    if (label === "nominee1") {
      const search = arr.find((ele) => !!ele.name && ele.name === value);
      if (!!search) {
        setfirst_nomineeDetails({
          ...first_nomineeDetails,
          name: { value: "" },
        });
        alert("Nominee Names cannot be same");
        return;
      }
      setfirst_nomineeDetails({
        ...first_nomineeDetails,
        name: { value: value },
      });
    }
    if (label === "nominee2") {
      const search = arr.find((ele) => !!ele.name && ele.name === value);
      if (!!search) {
        setsecond_nomineeDetails({
          ...second_nomineeDetails,
          name: { value: "" },
        });
        alert("Nominee Names cannot be same");
        return;
      }
      setsecond_nomineeDetails({
        ...second_nomineeDetails,
        name: { value: value },
      });
    }
    if (label === "nominee3") {
      const search = arr.find((ele) => !!ele.name && ele.name === value);
      if (!!search) {
        setthird_nomineeDetails({
          ...third_nomineeDetails,
          name: { value: "" },
        });
        alert("Nominee Names cannot be same");
        return;
      }
      setthird_nomineeDetails({
        ...third_nomineeDetails,
        name: { value: value },
      });
    }
  };
  const submit = async () => {
    if (!nominate_yes_or_no && props.store_pan.charAt(3) !== "H") {
      if (nominee_list >= 1) {
        if (!nameRegex.test(first_nomineeDetails.name.value)) {
          setfirst_nomineeDetails({
            ...first_nomineeDetails,
            name: {
              value: "",
              isError: true,
              errorMessage: "Name is mandatory",
            },
          });
          return;
        }
        if (!first_nomineeDetails.relationship.value) {
          setfirst_nomineeDetails({
            ...first_nomineeDetails,
            relationship: {
              isError: true,
              errorMessage: "Select the Relationship",
            },
          });
          return;
        }
        if (!first_nomineeDetails.dob.value) {
          setfirst_nomineeDetails({
            ...first_nomineeDetails,
            dob: {
              value: "",
              isError: true,
              errorMessage: "Select the Date of Birth",
            },
          });
          return;
        }
        if (
          !!nominee_dateofbirth.first_nominee_dateofbirth &&
          first_nomineeDetails.gaurdianname.value == ""
        ) {
          setfirst_nomineeDetails({
            ...first_nomineeDetails,
            gaurdianname: {
              isError: true,
              errorMessage: "Enter the Guardian Name",
            },
          });
          return;
        }
        if (
          !!nominee_dateofbirth.first_nominee_dateofbirth &&
          !panRegex.test(first_nomineeDetails.gaurdianpan.value)
        ) {
          setfirst_nomineeDetails({
            ...first_nomineeDetails,
            gaurdianpan: {
              isError: true,
              errorMessage: "Enter valid Guardian PAN",
            },
          });
          return;
        }
        if (!first_nomineeDetails.gender.value) {
          setfirst_nomineeDetails({
            ...first_nomineeDetails,
            gender: {
              isError: true,
              errorMessage: "Select the gender",
            },
          });
          return;
        }
        if (
          first_nomineeDetails.email.value.length > 0 &&
          (!emailRegex.test(first_nomineeDetails.email.value) ||
            !first_nomineeDetails.email.value.includes("."))
        ) {
          setfirst_nomineeDetails({
            ...first_nomineeDetails,
            email: {
              value: "",
              isError: true,
              errorMessage: "Enter valid Email id",
            },
          });
          return;
        }
        if (nominee_list >= 2) {
          if (!nameRegex.test(second_nomineeDetails.name.value)) {
            setsecond_nomineeDetails({
              ...second_nomineeDetails,
              name: {
                value: "",
                isError: true,
                errorMessage: "Name is mandatory",
              },
            });
            return;
          }
          if (!second_nomineeDetails.relationship.value) {
            setsecond_nomineeDetails({
              ...second_nomineeDetails,
              relationship: {
                isError: true,
                errorMessage: "Select the Relationship",
              },
            });
            return;
          }
          if (!second_nomineeDetails.dob.value) {
            setsecond_nomineeDetails({
              ...second_nomineeDetails,
              dob: {
                value: "",
                isError: true,
                errorMessage: "Select the Date of Birth",
              },
            });
            return;
          }
          if (
            !!nominee_dateofbirth.second_nominee_dateofbirth &&
            second_nomineeDetails.gaurdianname.value == ""
          ) {
            setsecond_nomineeDetails({
              ...second_nomineeDetails,
              gaurdianname: {
                isError: true,
                errorMessage: "Enter the Guardian Name",
              },
            });
            return;
          }
          if (
            !!nominee_dateofbirth.second_nominee_dateofbirth &&
            !panRegex.test(second_nomineeDetails.gaurdianpan.value)
          ) {
            setsecond_nomineeDetails({
              ...second_nomineeDetails,
              gaurdianpan: {
                isError: true,
                errorMessage: "Enter valid Guardian PAN",
              },
            });
            return;
          }
          if (!second_nomineeDetails.gender.value) {
            setsecond_nomineeDetails({
              ...second_nomineeDetails,
              gender: {
                isError: true,
                errorMessage: "Select the gender",
              },
            });
            return;
          }
          if (
            second_nomineeDetails.email.value.length > 0 &&
            (!emailRegex.test(second_nomineeDetails.email.value) ||
              !second_nomineeDetails.email.value.includes("."))
          ) {
            setsecond_nomineeDetails({
              ...second_nomineeDetails,
              email: {
                value: "",
                isError: true,
                errorMessage: "Enter valid Email id",
              },
            });
            return;
          }
        }
      }
      if (nominee_list >= 3) {
        if (!nameRegex.test(third_nomineeDetails.name.value)) {
          setthird_nomineeDetails({
            ...third_nomineeDetails,
            name: {
              value: "",
              isError: true,
              errorMessage: "Name is mandatory",
            },
          });
          return;
        }
        if (!third_nomineeDetails.relationship.value) {
          setthird_nomineeDetails({
            ...third_nomineeDetails,
            relationship: {
              isError: true,
              errorMessage: "Select the Relationship",
            },
          });
          return;
        }
        if (!third_nomineeDetails.dob.value) {
          setthird_nomineeDetails({
            ...third_nomineeDetails,
            dob: {
              value: "",
              isError: true,
              errorMessage: "Select the Date of Birth",
            },
          });
          return;
        }
        if (
          !!nominee_dateofbirth.third_nominee_dateofbirth &&
          third_nomineeDetails.gaurdianname.value == ""
        ) {
          setthird_nomineeDetails({
            ...third_nomineeDetails,
            gaurdianname: {
              isError: true,
              errorMessage: "Enter the Guardian Name",
            },
          });
          return;
        }
        if (
          !!nominee_dateofbirth.third_nominee_dateofbirth &&
          !panRegex.test(third_nomineeDetails.gaurdianpan.value)
        ) {
          setthird_nomineeDetails({
            ...third_nomineeDetails,
            gaurdianpan: {
              isError: true,
              errorMessage: "Enter valid Guardian PAN",
            },
          });
          return;
        }
        if (!third_nomineeDetails.gender.value) {
          setthird_nomineeDetails({
            ...third_nomineeDetails,
            gender: {
              isError: true,
              errorMessage: "Select the gender",
            },
          });
        }
        if (
          third_nomineeDetails.email.value.length > 0 &&
          !emailRegex.test(
            third_nomineeDetails.email.value ||
              !third_nomineeDetails.email.value.includes(".")
          )
        ) {
          setthird_nomineeDetails({
            ...third_nomineeDetails,
            email: {
              value: "",
              isError: true,
              errorMessage: "Enter valid Email Id",
            },
          });
          return;
        }
      }
    }

    setIsLoading(true);
    const NomineeDetails = {
      ...(!nominate_yes_or_no && {
        i_nominee: first_nomineeDetails.name.value,
        i_nompan1: first_nomineeDetails.pan.value,
        i_NomRelation:
          first_nomineeDetails.relationship.value === "Other"
            ? first_nomineeDetails.otherrelationship.value
            : first_nomineeDetails.relationship.value,
        i_NomDOB: first_nomineeDetails.dob.value,
        nom1gender: first_nomineeDetails.gender.value,
        i_Nominee1percentage: first_nomineeDetails.percentage.value,
        nom1email: first_nomineeDetails.email.value,
        i_nomadd1: first_nomineeDetails.address.value,
        i_nomcountry: first_nomineeDetails.country.value,
        i_nomstate: first_nomineeDetails.state.value,
        i_nomcity: first_nomineeDetails.city.value,
        i_nompin: first_nomineeDetails.pincode.value,
        i_nomguardianname1: first_nomineeDetails.gaurdianname.value,
        i_nomguardianpan1: first_nomineeDetails.gaurdianpan.value,
        i_namguardianrelationship1:
          first_nomineeDetails.gaurdianrelationship.value,
      }),
      ...(!nominate_yes_or_no && nominee_list > 1
        ? {
            i_nominee2: second_nomineeDetails.name.value,
            i_nompan2: second_nomineeDetails.pan.value,
            i_NomRelation2:
              second_nomineeDetails.relationship.value === "Other"
                ? second_nomineeDetails.otherrelationship.value
                : second_nomineeDetails.relationship.value,
            i_NomDOB2: second_nomineeDetails.dob.value,
            nom2gender: second_nomineeDetails.gender.value,
            i_Nominee2percentage: second_nomineeDetails.percentage.value,
            nom2email: second_nomineeDetails.email.value,
            i_nomadd21: second_nomineeDetails.address.value,
            i_nom2country: second_nomineeDetails.country.value,
            i_nomstate2: second_nomineeDetails.state.value,
            i_nomcity2: second_nomineeDetails.city.value,
            i_nompin2: second_nomineeDetails.pincode.value,
            i_nomguardianname2: second_nomineeDetails.gaurdianname.value,
            i_nomguardianpan2: second_nomineeDetails.gaurdianpan.value,
            i_namguardianrelationship2:
              second_nomineeDetails.gaurdianrelationship.value,
          }
        : {}),
      ...(!nominate_yes_or_no && nominee_list > 2
        ? {
            i_nominee3: third_nomineeDetails.name.value,
            i_nompan3: third_nomineeDetails.pan.value,
            i_NomRelation3:
              third_nomineeDetails.relationship.value === "Other"
                ? third_nomineeDetails.otherrelationship.value
                : third_nomineeDetails.relationship.value,
            i_NomDOB3: third_nomineeDetails.dob.value,
            nom3gender: third_nomineeDetails.gender.value,
            i_Nominee3percentage: third_nomineeDetails.percentage.value,
            nom3email: third_nomineeDetails.email.value,
            i_nomadd31: third_nomineeDetails.address.value,
            i_nom3country: third_nomineeDetails.country.value,
            i_nomstate3: third_nomineeDetails.state.value,
            i_nomcity3: third_nomineeDetails.city.value,
            i_nompin3: third_nomineeDetails.pincode.value,
            i_nomguardianname3: third_nomineeDetails.gaurdianname.value,
            i_nomguardianpan3: third_nomineeDetails.gaurdianpan.value,
            i_namguardianrelationship3:
              third_nomineeDetails.gaurdianrelationship.value,
          }
        : {}),
    };
    setIsLoading(false);
    props.storeNomineeDetails(NomineeDetails);
    props.history.replace("/new-investor-transaction/bank-details");
  };

  return (
    <>
      <CustomLoader display={isLoading} />
      {props.store_pan.charAt(3) !== "H" ? (
        <CardComponent title="Nominee Details">
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <div className="container-margin-nominee">
              <Checkbox
                onChange={handleNominees}
                checked={nominate_yes_or_no}
              />
              <span>I Wish not to nominate</span>
            </div>
            {!nominate_yes_or_no && (
              <div className="container-margin-nominee">
                <Checkbox
                  checked={same_as_first_appicant_address}
                  onChange={handleAddress}
                />
                <span> Same as First Applicant Address</span>
              </div>
            )}
          </div>
          {!nominate_yes_or_no && (
            <div>
              <div className="fatca-input-margin">
                <CustomizedSelect
                  fatcawidth={true}
                  placeholder={"Select One"}
                  name="Total no of Nominees"
                  value={nominee_list}
                  handleChange={handleChangeNomineeList}
                >
                  {NomineesList.map((item, index) => (
                    <MenuItem value={item.value} key={index}>
                      {item.value}
                    </MenuItem>
                  ))}
                </CustomizedSelect>
              </div>
              {nominee_list >= 1 && (
                <div>
                  <div className="input-name">Nominee 1:</div>
                  <div
                    className="new-investor-container"
                    style={{
                      padding: "10px 0px 10px 0px",
                      margin: "10px 0px 10px 0px",
                      border: "2px solid #e5f2f9",
                    }}
                  >
                    {NomineeListShow && (
                      <div className="fatca-input-margin">
                        <CustomizedSelect
                          placeholder={"Select One"}
                          fatcawidth={true}
                          name="Nominee List"
                          value={nominees_selected.nominee_selected1}
                          handleChange={handleNomineeList("nominee1")}
                        >
                          {nomineeList.map((item, index) => (
                            <MenuItem value={item.value} key={index}>
                              {item.value}
                            </MenuItem>
                          ))}
                        </CustomizedSelect>
                      </div>
                    )}

                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Nominee Name*"
                        value={first_nomineeDetails.name.value}
                        onChange={handleName("nominee1")}
                        disabled={
                          !!nominees_selected.nominee_selected1 &&
                          nominees_selected.nominee_selected1 !== "Add New"
                            ? true
                            : false
                        }
                        isShowError={first_nomineeDetails.name.isError}
                        errorMessage={first_nomineeDetails.name.errorMessage}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Nominee PAN"
                        value={
                          first_nomineeDetails.pan.value
                            ? first_nomineeDetails.pan.value
                            : ""
                        }
                        onChange={handleChangePan("firstNomineePan")}
                        isShowError={first_nomineeDetails.pan.isError}
                        errorMessage={first_nomineeDetails.pan.errorMessage}
                        onBlur={showError("firstNomineePan")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        fatcawidth={true}
                        placeholder={"Select One"}
                        name="Relationship*"
                        isError={first_nomineeDetails.relationship.isError}
                        errorMessage={
                          first_nomineeDetails.relationship.errorMessage
                        }
                        value={first_nomineeDetails.relationship.value}
                        handleChange={(event) =>
                          setfirst_nomineeDetails({
                            ...first_nomineeDetails,
                            relationship: { value: event.target.value },
                          })
                        }
                      >
                        {relationshipList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    {first_nomineeDetails.relationship.value == "Other" && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Relationship Name"
                          value={first_nomineeDetails.otherrelationship.value}
                          onChange={(event) =>
                            setfirst_nomineeDetails({
                              ...first_nomineeDetails,
                              otherrelationship: { value: event.target.value },
                            })
                          }
                        />
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <div className="input-name">Date of Birth*</div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          required={true}
                          className="selects"
                          style={{
                            width: "80%",
                            border: !!first_nomineeDetails.dob.isError
                              ? "1px solid red"
                              : "none",
                          }}
                          onChange={handleDateofBirth("dob1")}
                          openTo={true}
                          disableFuture={true}
                          format="dd/MM/yyyy"
                          maxDate={new Date()}
                          animateYearScrolling={true}
                          id="mui-pickers-date"
                          value={first_nomineeDetails.dob.value}
                        />
                      </MuiPickersUtilsProvider>
                      {!!first_nomineeDetails.dob.errorMessage && (
                        <div style={{ color: "red" }}>
                          {" "}
                          {first_nomineeDetails.dob.errorMessage}
                        </div>
                      )}
                    </div>
                    {nominee_dateofbirth.first_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Guardian Name*"
                          value={first_nomineeDetails.gaurdianname.value}
                          onChange={(event) =>
                            setfirst_nomineeDetails({
                              ...first_nomineeDetails,
                              gaurdianname: { value: event.target.value },
                            })
                          }
                          isShowError={
                            first_nomineeDetails.gaurdianname.isError
                          }
                          errorMessage={
                            first_nomineeDetails.gaurdianname.errorMessage
                          }
                        />
                      </div>
                    )}
                    {nominee_dateofbirth.first_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Guardian PAN*"
                          value={first_nomineeDetails.gaurdianpan.value}
                          onChange={handleChangePan("firstNomineeGuardianPan")}
                          // onChange={(event) => setfirst_nomineeDetails({ ...first_nomineeDetails, gaurdianpan:{value:event.target.value}})}
                          isShowError={first_nomineeDetails.gaurdianpan.isError}
                          errorMessage={
                            first_nomineeDetails.gaurdianpan.errorMessage
                          }
                          onBlur={showError("firstNomineeGuardianPan")}
                        />
                      </div>
                    )}
                    {nominee_dateofbirth.first_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <CustomizedSelect
                          fatcawidth={true}
                          placeholder={"Select One"}
                          name="Guardian Relationship"
                          value={
                            first_nomineeDetails.gaurdianrelationship.value
                          }
                          handleChange={(event) =>
                            setfirst_nomineeDetails({
                              ...first_nomineeDetails,
                              gaurdianrelationship: {
                                value: event.target.value,
                              },
                            })
                          }
                        >
                          {relationshipList.map((item, index) => (
                            <MenuItem value={item.value} key={index}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </CustomizedSelect>
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        placeholder={"Select One"}
                        fatcawidth={true}
                        name="Gender*"
                        value={first_nomineeDetails.gender.value}
                        isError={first_nomineeDetails.gender.isError}
                        errorMessage={first_nomineeDetails.gender.errorMessage}
                        handleChange={(event) =>
                          setfirst_nomineeDetails({
                            ...first_nomineeDetails,
                            gender: { value: event.target.value },
                          })
                        }
                      >
                        {genderOptions.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Percentage (%)"
                        type="number"
                        value={first_nomineeDetails.percentage.value}
                        onChange={handlePercentage("first")}
                        disabled={
                          nominee_list === "1" &&
                          !props.nomineDetails.i_Nominee1percentage
                            ? true
                            : false
                        }
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Email ID"
                        value={first_nomineeDetails.email.value}
                        onChange={(event) =>
                          setfirst_nomineeDetails({
                            ...first_nomineeDetails,
                            email: { value: event.target.value },
                          })
                        }
                        isShowError={first_nomineeDetails.email.isError}
                        errorMessage={first_nomineeDetails.email.errorMessage}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Address"
                        value={first_nomineeDetails.address.value}
                        onChange={(event) =>
                          setfirst_nomineeDetails({
                            ...first_nomineeDetails,
                            address: { value: event.target.value },
                          })
                        }
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        fatcawidth={true}
                        placeholder={"Select One"}
                        name="Country"
                        value={first_nomineeDetails.country.value}
                        handleChange={(event) =>
                          setfirst_nomineeDetails({
                            ...first_nomineeDetails,
                            country: { value: event.target.value },
                          })
                        }
                      >
                        {countriesList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        name="State"
                        fatcawidth={true}
                        value={first_nomineeDetails.state.value}
                        onChange={handleState("firstState")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="City"
                        value={first_nomineeDetails.city.value}
                        onChange={handleCity("firstCity")}
                      />{" "}
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        type="number"
                        name="Pincode"
                        onChange={handlePincode("nominee1")}
                        value={first_nomineeDetails.pincode.value}
                        isShowError={first_nomineeDetails.pincode.isError}
                        errorMessage={first_nomineeDetails.pincode.errorMessage}
                      />
                    </div>
                  </div>
                </div>
              )}
              {nominee_list >= 2 && (
                <div>
                  <div className="input-name">Nominee 2:</div>

                  <div
                    className="new-investor-container"
                    style={{
                      padding: "10px 0px 10px 0px",
                      margin: "10px 0px 10px 0px",
                      border: "2px solid #e5f2f9",
                    }}
                  >
                    {NomineeListShow && (
                      <div className="fatca-input-margin">
                        <CustomizedSelect
                          placeholder={"Select One"}
                          fatcawidth={true}
                          name="Nominee List"
                          value={nominees_selected.nominee_selected2}
                          handleChange={handleNomineeList("nominee2")}
                        >
                          {nomineeList.map((item, index) => (
                            <MenuItem value={item.value} key={index}>
                              {item.value}
                            </MenuItem>
                          ))}
                        </CustomizedSelect>
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Nominee Name*"
                        onChange={handleName("nominee2")}
                        value={second_nomineeDetails.name.value}
                        disabled={
                          !!nominees_selected.nominee_selected2 &&
                          nominees_selected.nominee_selected2 !== "Add New"
                            ? true
                            : false
                        }
                        isShowError={second_nomineeDetails.name.isError}
                        errorMessage={second_nomineeDetails.name.errorMessage}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        onChange={handleChangePan("secondNomineePan")}
                        name="Nominee PAN"
                        value={second_nomineeDetails.pan.value}
                        isShowError={second_nomineeDetails.pan.isError}
                        errorMessage={second_nomineeDetails.pan.errorMessage}
                        onBlur={showError("secondNomineePan")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        fatcawidth={true}
                        name="Relationship*"
                        placeholder={"Select One"}
                        value={second_nomineeDetails.relationship.value}
                        isError={second_nomineeDetails.relationship.isError}
                        errorMessage={
                          second_nomineeDetails.relationship.errorMessage
                        }
                        handleChange={(event) =>
                          setsecond_nomineeDetails({
                            ...second_nomineeDetails,
                            relationship: { value: event.target.value },
                          })
                        }
                      >
                        {relationshipList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    {second_nomineeDetails.relationship.value == "Other" && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Relationship Name"
                          value={second_nomineeDetails.otherrelationship.value}
                          onChange={(event) =>
                            setsecond_nomineeDetails({
                              ...second_nomineeDetails,
                              otherrelationship: { value: event.target.value },
                            })
                          }
                        />
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <div className="input-name">Date of Birth*</div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          required={true}
                          className="selects"
                          style={{
                            width: "80%",
                            border: !!second_nomineeDetails.dob.isError
                              ? "1px solid red"
                              : "none",
                          }}
                          onChange={handleDateofBirth("dob2")}
                          disableFuture={true}
                          format="dd/MM/yyyy"
                          maxDate={new Date()}
                          // animateYearScrolling={true}
                          id="mui-pickers-date"
                          value={second_nomineeDetails.dob.value}
                        />
                      </MuiPickersUtilsProvider>
                      {!!second_nomineeDetails.dob.errorMessage && (
                        <div style={{ color: "red" }}>
                          {" "}
                          {second_nomineeDetails.dob.errorMessage}
                        </div>
                      )}
                    </div>
                    {nominee_dateofbirth.second_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Guardian Name*"
                          value={second_nomineeDetails.gaurdianname.value}
                          onChange={(event) =>
                            setsecond_nomineeDetails({
                              ...second_nomineeDetails,
                              gaurdianname: { value: event.target.value },
                            })
                          }
                          isShowError={
                            second_nomineeDetails.gaurdianname.isError
                          }
                          errorMessage={
                            second_nomineeDetails.gaurdianname.errorMessage
                          }
                        />
                      </div>
                    )}
                    {nominee_dateofbirth.second_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Guardian PAN*"
                          onChange={handleChangePan("secondNomineeGuardianPan")}
                          value={second_nomineeDetails.gaurdianpan.value}
                          isShowError={
                            second_nomineeDetails.gaurdianpan.isError
                          }
                          errorMessage={
                            second_nomineeDetails.gaurdianpan.errorMessage
                          }
                          onBlur={showError("secondNomineeGuardianPan")}
                        />
                      </div>
                    )}
                    {nominee_dateofbirth.second_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <CustomizedSelect
                          fatcawidth={true}
                          placeholder={"Select One"}
                          name="Guardian Relationship"
                          value={
                            second_nomineeDetails.gaurdianrelationship.value
                          }
                          handleChange={(event) =>
                            setsecond_nomineeDetails({
                              ...second_nomineeDetails,
                              gaurdianrelationship: {
                                value: event.target.value,
                              },
                            })
                          }
                        >
                          {relationshipList.map((item, index) => (
                            <MenuItem value={item.value} key={index}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </CustomizedSelect>
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        fatcawidth={true}
                        placeholder={"Select One"}
                        name="Gender*"
                        value={second_nomineeDetails.gender.value}
                        isError={second_nomineeDetails.gender.isError}
                        errorMessage={second_nomineeDetails.gender.errorMessage}
                        handleChange={(event) =>
                          setsecond_nomineeDetails({
                            ...second_nomineeDetails,
                            gender: { value: event.target.value },
                          })
                        }
                      >
                        {genderOptions.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>{" "}
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        placeholder={"Select One"}
                        name="Percentage (%)*"
                        type="number"
                        value={second_nomineeDetails.percentage.value}
                        onChange={handlePercentage("second")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Email ID"
                        value={second_nomineeDetails.email.value}
                        onChange={(event) =>
                          setsecond_nomineeDetails({
                            ...second_nomineeDetails,
                            email: { value: event.target.value },
                          })
                        }
                        isShowError={second_nomineeDetails.email.isError}
                        errorMessage={second_nomineeDetails.email.errorMessage}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Address"
                        value={second_nomineeDetails.address.value}
                        onChange={(event) =>
                          setsecond_nomineeDetails({
                            ...second_nomineeDetails,
                            address: { value: event.target.value },
                          })
                        }
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        fatcawidth={true}
                        placeholder={"Select One"}
                        name="Country"
                        value={second_nomineeDetails.country.value}
                        handleChange={(event) =>
                          setsecond_nomineeDetails({
                            ...second_nomineeDetails,
                            country: { value: event.target.value },
                          })
                        }
                      >
                        {countriesList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="State"
                        value={second_nomineeDetails.state.value}
                        onChange={handleState("secondState")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="City"
                        value={second_nomineeDetails.city.value}
                        onChange={handleCity("secondCity")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        type="number"
                        name="Pincode"
                        value={second_nomineeDetails.pincode.value}
                        onChange={handlePincode("nominee2")}
                        isShowError={second_nomineeDetails.pincode.isError}
                        errorMessage={
                          second_nomineeDetails.pincode.errorMessage
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              {nominee_list >= 3 && (
                <div>
                  <div className="input-name">Nominee 3:</div>
                  <div
                    className="new-investor-container"
                    style={{
                      padding: "10px 0px 10px 0px",
                      margin: "10px 0px 10px 0px",
                      border: "2px solid #e5f2f9",
                    }}
                  >
                    {NomineeListShow && (
                      <div className="fatca-input-margin">
                        <CustomizedSelect
                          fatcawidth={true}
                          name="Nominee List"
                          placeholder={"Select One"}
                          value={nominees_selected.nominee_selected3}
                          handleChange={handleNomineeList("nominee3")}
                        >
                          {nomineeList.map((item, index) => (
                            <MenuItem value={item.value} key={index}>
                              {item.value}
                            </MenuItem>
                          ))}
                        </CustomizedSelect>
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Nominee Name*"
                        onChange={handleName("nominee3")}
                        disabled={
                          !!nominees_selected.nominee_selected3 &&
                          nominees_selected.nominee_selected3 !== "Add New"
                            ? true
                            : false
                        }
                        value={third_nomineeDetails.name.value}
                        isShowError={third_nomineeDetails.name.isError}
                        errorMessage={third_nomineeDetails.name.errorMessage}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        onChange={handleChangePan("thirdNomineePan")}
                        name="Nominee PAN"
                        value={third_nomineeDetails.pan.value}
                        isShowError={third_nomineeDetails.pan.isError}
                        errorMessage={third_nomineeDetails.pan.errorMessage}
                        onBlur={showError("thirdNomineePan")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        fatcawidth={true}
                        name="Relationship*"
                        placeholder={"Select One"}
                        value={third_nomineeDetails.relationship.value}
                        isError={third_nomineeDetails.relationship.isError}
                        errorMessage={
                          third_nomineeDetails.relationship.errorMessage
                        }
                        handleChange={(event) =>
                          setthird_nomineeDetails({
                            ...third_nomineeDetails,
                            relationship: { value: event.target.value },
                          })
                        }
                      >
                        {relationshipList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    {third_nomineeDetails.relationship.value == "Other" && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Relationship Name"
                          value={third_nomineeDetails.otherrelationship.value}
                          onChange={(event) =>
                            setthird_nomineeDetails({
                              ...third_nomineeDetails,
                              otherrelationship: { value: event.target.value },
                            })
                          }
                        />
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <div className="input-name">Date of Birth*</div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          required={true}
                          className="selects"
                          style={{
                            width: "80%",
                            border: !!third_nomineeDetails.dob.isError
                              ? "1px solid red"
                              : "none",
                          }}
                          onChange={handleDateofBirth("dob3")}
                          // openTo={true}
                          disableFuture={true}
                          format="dd/MM/yyyy"
                          maxDate={new Date()}
                          // animateYearScrolling={true}
                          id="mui-pickers-date"
                          value={third_nomineeDetails.dob.value}
                        />
                      </MuiPickersUtilsProvider>
                      {!!third_nomineeDetails.dob.errorMessage && (
                        <div style={{ color: "red" }}>
                          {" "}
                          {third_nomineeDetails.dob.errorMessage}
                        </div>
                      )}
                    </div>
                    {nominee_dateofbirth.third_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Guardian Name*"
                          value={third_nomineeDetails.gaurdianname.value}
                          onChange={(event) =>
                            setthird_nomineeDetails({
                              ...third_nomineeDetails,
                              gaurdianname: { value: event.target.value },
                            })
                          }
                          isShowError={
                            third_nomineeDetails.gaurdianname.isError
                          }
                          errorMessage={
                            third_nomineeDetails.gaurdianname.errorMessage
                          }
                        />
                      </div>
                    )}
                    {nominee_dateofbirth.third_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <Input
                          fatcawidth={true}
                          name="Guardian PAN*"
                          value={third_nomineeDetails.gaurdianpan.value}
                          onChange={handleChangePan("thirdNomineeGuardianPan")}
                          isShowError={third_nomineeDetails.gaurdianpan.isError}
                          errorMessage={
                            third_nomineeDetails.gaurdianpan.errorMessage
                          }
                          onBlur={showError("thirdNomineeGuardianPan")}
                        />
                      </div>
                    )}
                    {nominee_dateofbirth.third_nominee_dateofbirth && (
                      <div className="fatca-input-margin">
                        <CustomizedSelect
                          placeholder={"Select One"}
                          fatcawidth={true}
                          name="Guardian Relationship"
                          value={
                            third_nomineeDetails.gaurdianrelationship.value
                          }
                          handleChange={(event) =>
                            setthird_nomineeDetails({
                              ...third_nomineeDetails,
                              gaurdianrelationship: {
                                value: event.target.value,
                              },
                            })
                          }
                        >
                          {relationshipList.map((item, index) => (
                            <MenuItem value={item.value} key={index}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </CustomizedSelect>
                      </div>
                    )}
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        placeholder={"Select One"}
                        fatcawidth={true}
                        name="Gender*"
                        value={third_nomineeDetails.gender.value}
                        isError={third_nomineeDetails.gender.isError}
                        errorMessage={third_nomineeDetails.gender.errorMessage}
                        handleChange={(event) =>
                          setthird_nomineeDetails({
                            ...third_nomineeDetails,
                            gender: { value: event.target.value },
                          })
                        }
                      >
                        {genderOptions.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Percentage (%)*"
                        type="number"
                        value={third_nomineeDetails.percentage.value}
                        onChange={handlePercentage("third")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="Email ID"
                        value={third_nomineeDetails.email.value}
                        onChange={(event) =>
                          setthird_nomineeDetails({
                            ...third_nomineeDetails,
                            email: { value: event.target.value },
                          })
                        }
                        isShowError={third_nomineeDetails.email.isError}
                        errorMessage={third_nomineeDetails.email.errorMessage}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        name="Address"
                        value={third_nomineeDetails.address.value}
                        onChange={(event) =>
                          setthird_nomineeDetails({
                            ...third_nomineeDetails,
                            address: { value: event.target.value },
                          })
                        }
                        fatcawidth={true}
                      />
                    </div>{" "}
                    <div className="fatca-input-margin">
                      <CustomizedSelect
                        fatcawidth={true}
                        placeholder={"Select One"}
                        name="Country"
                        value={third_nomineeDetails.country.value}
                        handleChange={(event) =>
                          setthird_nomineeDetails({
                            ...third_nomineeDetails,
                            country: { value: event.target.value },
                          })
                        }
                      >
                        {countriesList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>{" "}
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="State"
                        value={third_nomineeDetails.state.value}
                        onChange={handleState("thirdState")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        name="City"
                        value={third_nomineeDetails.city.value}
                        onChange={handleCity("thirdCity")}
                      />
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        fatcawidth={true}
                        type="number"
                        name="Pincode"
                        onChange={handlePincode("nominee3")}
                        value={third_nomineeDetails.pincode.value}
                        isShowError={third_nomineeDetails.pincode.isError}
                        errorMessage={third_nomineeDetails.pincode.errorMessage}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </CardComponent>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          “Nominee section is disabled for HUF Investor”
        </div>
      )}
      <div className="d-flex justify-content-end">
        <button
          className="new-investor-button"
          onClick={() =>
            props.history.replace("/new-investor-transaction/fatca-details")
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          PROCEED
        </button>
      </div>
    </>
  );
};
export default connect(
  ({ newinvestor }) => {
    const {
      applicantparams,
      fatcaDetails,
      getnomineeDetails,
      nomineDetails,
      address,
      store_pan,
    } = newinvestor;
    return {
      fatcaDetails,
      applicantparams,
      getnomineeDetails,
      nomineDetails,
      address,
      store_pan,
    };
  },
  {
    getCountriesList,
    getStatesList,
    storeApplicantParams,
    getKycDetails,
    checkKyc,
    getCitiesByState,
    getRelationShipList,
    storeNomineeDetails,
    getNomineeDetails,
  }
)(NomineeDetails);
